// src/ComponnentsUI/common/Badge.tsx

import React from 'react';

// Add 'neutral' to the available variants
type BadgeVariant = 'info' | 'success' | 'warning' | 'danger' | 'special' | 'neutral';

interface BadgeProps {
  text: string;
  variant: BadgeVariant;
}

export const Badge: React.FC<BadgeProps> = ({ text, variant }) => {
  const styles: Record<BadgeVariant, string> = {
    info: 'bg-blue-100 dark:bg-blue-900/30 text-blue-800 dark:text-blue-400',
    success: 'bg-green-100 dark:bg-green-900/30 text-green-800 dark:text-green-400',
    special: 'bg-purple-100 dark:bg-purple-900/30 text-purple-800 dark:text-purple-400',
    warning: 'bg-yellow-100 dark:bg-yellow-900/30 text-yellow-800 dark:text-yellow-400',
    danger: 'bg-red-100 dark:bg-red-900/30 text-red-800 dark:text-red-400',
    neutral: 'bg-gray-100 dark:bg-gray-700 text-gray-800 dark:text-gray-300', 
  };

  return (
    <span className={`px-2.5 py-0.5 text-xs font-medium rounded-full capitalize ${styles[variant]}`}>
      {text}
    </span>
  );
};